module.exports = __webpack_public_path__ + "b66bf8994c3a95f8b9ebcdec5a1e510a.svg";